import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SpecialistListPreviewComponent} from '../specialist-list-preview.component';
import {WizardSpecialist} from '../../../../../pages/packages/wizard/models/wizard-specialist';

@Component({
    selector: 'app-specialist-wizard-list-preview',
    templateUrl: 'specialist-wizard-list-preview.component.html',
    styleUrls: ['../specialist-list-preview.component.scss'],
})

export class SpecialistWizardListPreviewComponent extends SpecialistListPreviewComponent {
    @Input() specialist: WizardSpecialist;

    @Output() checkChange = new EventEmitter<boolean>();

    onCheckChange(checked: boolean) {
        this.checkChange.emit(checked);
    }
}
